import { Controller } from "@hotwired/stimulus"

// Shows a panel only while a select holds a particular value.
//
//   <div data-controller="reveal" data-reveal-match-value="deprecated">
//     <select data-reveal-target="source" data-action="change->reveal#update">…</select>
//     <div data-reveal-target="panel" hidden>…</div>
//   </div>
//
// Deliberately does not hide the panel on connect: the server decides the initial
// state, so a form re-rendered after a failed validation keeps the panel open with
// the message still attached to it. With no JavaScript the panel simply stays
// wherever the server put it, which is why the server must render it visible
// whenever the value already matches — otherwise the field would be unreachable.
export default class extends Controller {
  static targets = ["source", "panel"]
  static values = { match: String }

  update() {
    if (!this.hasSourceTarget || !this.hasPanelTarget) return

    const matches = this.sourceTarget.value === this.matchValue
    this.panelTarget.hidden = !matches

    // Moving focus into a field the person just caused to appear saves a click
    // and makes the change obvious to a screen reader, which would otherwise get
    // no announcement at all.
    if (matches) this.panelTarget.querySelector("textarea, input, select")?.focus()
  }
}
